import { io } from 'socket.io-client';

/** @typedef {import('socket.io-client').Socket} Socket **/

/**
 * @typedef {Object} DeskReceiverOptions
 * @property {string} host
 * @property {number} port
 * @property {string|undefined} path
 * @property {string} token
 */

/**
 * @typedef {Object} SetHeightData
 * @property {number} height
 */

/**
 * @typedef {{
 *     height: number,
 *     targetHeight: number,
 * }} ReceiverState
 */

export class DeskReceiver {
    /**
     * @type {DeskReceiverOptions}
     * @private
     */
    options;

    /**
     * @type {Socket}
     * @private
     */
    io;

    /**
     * @param {DeskReceiverOptions} options
     */
    constructor(options) {
        this.options = options;

        this.io = io(undefined, {
            query: {
                type: 'receiver',
            },
            auth: {
                token: options.token,
            },
            forceNew: true,
        });
    }
    connect() {
        this.io.connect();
    }

    /**
     * @param {(data: SetHeightData) => void} handler
     */
    onSetHeight(handler) {
        this.io.on('set-height', (data) => {
            handler(data);
        });
    }

    /**
     * @param {() => void} handler
     */
    onRequestState(handler) {
        this.io.on('request-state', () => {
            handler();
        });
    }

    /**
     * @param {ReceiverState} state
     */
    giveState(state) {
        this.io.emit('give-state', {
            height: state.height,
            targetHeight: state.targetHeight,
        });
    }
}
